import { render, staticRenderFns } from "./tableRelations.vue?vue&type=template&id=224ae8b4&"
import script from "./tableRelations.vue?vue&type=script&lang=js&"
export * from "./tableRelations.vue?vue&type=script&lang=js&"
import style0 from "./tableRelations.vue?vue&type=style&index=0&id=224ae8b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports